module.exports = __webpack_public_path__ + "static/img/fenzu2.445ac97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/fenzu2.png
// module id = o7lV
// module chunks = 24